import { EntityDropdown } from '../EntityDropdown/EntityDropdown';
import { FetchEntityCheckBox } from '../FetchEntityCheckBox/FetchEntityCheckBox';
import { SubscriptionEndpointField } from '../SubscriptionEndpointField/SubscriptionEndpointField';
import { SubscriptionEntityFields } from '../SubscriptionEntityFields/SubscriptionEntityFields';
import { SubscriptionPolicyIdField } from '../SubscriptionPolicyIdField/SubscriptionPolicyIdField';
import styles from './subscriptionEntity.module.scss';

export const SubscriptionEntity = ({ itemKey, entityIndex }) => {
    return (
        <div className={styles['row-fields']}>
            <SubscriptionEndpointField />
            <SubscriptionPolicyIdField />
            <div className={styles['row-list']}>
                <div className={styles['columns']}>
                    <EntityDropdown />
                    <FetchEntityCheckBox />
                </div>
                <div className={styles['fields']}>
                    <SubscriptionEntityFields itemKey={itemKey} entityIndex={entityIndex} />
                </div>
            </div>
        </div>
    );
};
